import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Bonus3() {
  const benefits = ['The exact "photos first" protocol (before you touch anything)', 'Hour-by-hour action plan: 0–2 hrs / 2–6 hrs / 6–12 hrs / 12–24 hrs / 24–48 hrs / 48–72 hrs', 'What to bring on your first visit (10-item pack list)', 'How to find and collect the documents that control the timeline', 'The 3 utility rules: what to keep on, what to turn off, and what to never touch blindly', 'The "minimum inventory" method to prevent family conflict over belongings', 'A 1-page printable checklist to bring to the house'];
  return <section className="bg-[#fdfbf7] py-12 md:py-20 px-6 border-b border-gold/20" data-id="element-43">
      <div className="max-w-6xl mx-auto" data-id="element-44">
        <div className="flex flex-col lg:flex-row-reverse gap-6 lg:gap-12 items-center" data-id="element-45">
          <div className="w-full lg:w-1/3 flex justify-center" data-id="element-46">
            <img src="https://cdn.magicpatterns.com/uploads/fsmXraetYNQ5ZABHHmR95j/Bonus_3_image_The_Inherited_House.png" alt="The 72-Hour House Lockdown Checklist" className="w-full max-w-sm object-contain drop-shadow-editorial rounded-lg" data-id="element-47" />
          </div>

          <div className="w-full lg:w-2/3" data-id="element-48">
            <div className="inline-block bg-amber-100 text-amber-800 font-bold px-4 py-1 rounded-full text-sm mb-4 uppercase tracking-wider" data-id="element-49">
              BONUS #3
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy mb-2" data-id="element-50">
              The 72-Hour House Lockdown Checklist
            </h2>
            <h3 className="text-xl md:text-2xl text-navy-light font-heading italic mb-2" data-id="element-51">
              "Secure the Property Without Losing Money"
            </h3>
            <p className="text-lg text-slate font-medium mb-8" data-id="element-52">
              Value: $9.99 — Yours FREE Today
            </p>

            <div className="space-y-4 text-text-dark font-body text-lg leading-relaxed mb-8" data-id="element-53">
              <p data-id="element-54">
                The moment you have access to that house — the clock starts.
              </p>
              <p data-id="element-55">
                Unsecured homes get broken into. Small leaks become $8,000 water
                damage claims. Relatives "stop by" and things disappear. Mail
                piles up and deadlines get missed.
              </p>
              <p data-id="element-56">
                The 72-Hour Lockdown Checklist gives you a step-by-step action
                plan for the first 3 days — so none of that happens to you.
              </p>
            </div>

            <h4 className="text-xl font-bold text-navy mb-4" data-id="element-57">
              Here's what's inside:
            </h4>
            <ul className="space-y-3 mb-8" data-id="element-58">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-59">
                  <CheckCircle2 className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-60" />
                  <span className="text-text-dark text-lg" data-id="element-61">{benefit}</span>
                </li>)}
            </ul>

            <div className="bg-white p-6 rounded-xl border border-slate-light/20 shadow-sm space-y-4" data-id="element-62">
              <p className="text-text-dark font-body" data-id="element-63">
                <strong className="text-navy" data-id="element-64">Who this is for:</strong> Anyone
                who hasn't visited the house yet — or anyone who went in without
                a plan and needs to go back with one.
              </p>
              <p className="text-text-dark font-body" data-id="element-65">
                <strong className="text-navy" data-id="element-66">What it prevents:</strong>{' '}
                Expensive mistakes, family arguments, and missed deadlines that
                happen in the first 72 hours.
              </p>
              <blockquote className="border-l-4 border-gold pl-4 italic text-slate mt-4" data-id="element-67">
                "I didn't know I needed this until I was standing in the
                driveway with no idea where to start. This was the plan I didn't
                have." — Verified reader
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>;
}